<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />
        <transition name="fade">
            <div v-if="selectedRowIndex < 0">
                <div>
                    <div class="form-row align-items-center">
                        <div class="col-8">
                            <label class="sr-only" for="search">Search</label>
                            <input type="text" class="form-control mb-2" id="search" placeholder="Authorisation ID / Claim Reference / Job ID" v-model="searchFor">
                        </div>
                        <div class="col-auto">
                            <div class="form-check mb-2">
                                <input class="form-check-input" type="checkbox" id="autoSizingCheck" v-model="onlyExceptions">
                                <label class="form-check-label" for="autoSizingCheck">
                                    Exceptions
                                </label>
                            </div>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary mb-2" v-on:click="search({ searchValues: searchFor, onlyExceptions: onlyExceptions })">Search</button>
                        </div>
                    </div>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Processed</th>
                            <th scope="col">Authorisation ID</th>
                            <th scope="col">Claim Reference</th>
                            <th scope="col">Job ID</th>
                            <th scope="col">Exceptions</th>
                            <th scope="col">...</th>
                        </tr>
                    </thead>
                    <tbody v-if="loading == true">
                        <tr>
                            <td colspan="5">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(r, idx) in rows" :key="'rows_' + idx">
                            <td>{{r.dateCreated}}</td>
                            <td>{{r.autH_ID}}</td>
                            <td>{{r.claimReference}}</td>
                            <td>{{r.supplieR_JOB_ID}}</td>
                            <td>{{r.lineExceptionsJson != null  && r.lineExceptionsJson.length > 0 ? 'YES' : 'NO'}}</td>
                            <td>
                                <a href="javascript:void(0)" v-on:click="viewJson(r.lineExceptionsJson && r.lineExceptionsJson.length > 0 ? r.lineExceptionsJson : null)">View Exceptions</a><br />
                                <a href="javascript:void(0)" v-on:click="viewJson(r.loadResultJson && r.loadResultJson.length > 0 ? r.loadResultJson : null)">View Result</a><br />
                                <a href="javascript:void(0)" v-on:click="showRow(idx)">View Row</a>
                            </td>
                        </tr>
                        <tr v-if="rows == null || rows.length == 0">
                            <td colspan="6">
                                No records...
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination v-model="pageNumber"
                              :total-rows="totalRecords"
                              :per-page="pageSize"
                              aria-controls="my-table"
                              pills>
                </b-pagination>
                <hr />
            </div>
            <div v-if="selectedRowIndex != -1">
                <div>
                    <a class="" href="javascript:void(0)" v-on:click="hideRow()">Back</a>
                </div>
                <hr />
                <div>
                    <dl class="row">
                        <template v-for="(val, prop, idx) in rows[selectedRowIndex]">
                            <dt class="col-sm-3 mt-2">{{prop}}</dt>
                            <dd v-if="prop=='lineExceptionsJson'" class="col-sm-9 mt-2">
                                <a href="javascript:void(0)" v-on:click="viewJson(val && val.length > 0 ? val : null)">View Exceptions</a><br />
                            </dd>
                            <dd v-else-if="prop=='loadResultJson'" class="col-sm-9 mt-2">
                                <a href="javascript:void(0)" v-on:click="viewJson(val && val.length > 0 ? val : null)">View Result</a><br />
                            </dd>
                            <dd v-else-if="prop=='sourceLine'" class="col-sm-9 mt-2">
                                <a href="javascript:void(0)" v-on:click="viewSource(val)">View Source</a><br />
                            </dd>
                            <dd v-else class="col-sm-9 mt-2">
                                {{val}}&nbsp;<copy-to-clipboard :textToCopy="val" />
                            </dd>
                        </template>
                    </dl>
                </div>
                <hr />
                <div>
                    <a class="" href="javascript:void(0)" v-on:click="hideRow()">Back</a>
                </div>
            </div>
        </transition>
        <b-modal :id="'json-viewer-modal-' + $vnode.key" title="JSON Viewer" size="lg" ok-only ok-variant="secondary" ok-title="Close">
            <div>
                <json-viewer v-model="jsonValue"
                             :viewMode="0" />
            </div>
        </b-modal>
        <b-modal :id="'text-viewer-modal-' + $vnode.key" title="Text Viewer" size="lg" ok-only ok-variant="secondary" ok-title="Close">
            <div>
                <textarea class="form-control form-control-sm"
                          rows="3"
                          :disabled="true">{{rowSourceVal}}</textarea> 
            </div>
        </b-modal>

    </div>
</template>

<script>
    import PageHeader from '@/components/PageHeader.vue'
    import JsonViewer from '@/components/jsonViewer.vue'
    import CopyToClipboard from '@/components/CopyToClipboard.vue'

    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    export default {
        name: 'PartnerImportRows',
        props: ['file', 'page'],
        components: {
            PageHeader,
            JsonViewer,
            CopyToClipboard
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Settlement Option Partner Import Rows',
                },
                rows: [],
                jsonValue: null,
                rowSourceVal: null,
                selectedRowIndex: -1,
                loading: false,
                pageNumber: 1,

                searchFor: null,
                onlyExceptions: false
            }
        },
        watch: {
            pageNumber: function (newVal, oldVal) {  
                let { searchFor, onlyExceptions } = this
                this.search({ searchFor, onlyExceptions })
            }
        },
        computed: {
            totalRecords() {
                if (this.rows && this.rows.length > 0) {
                    let firstRow = this.rows[0]
                    if (firstRow) {
                        return firstRow.totalRecords
                    }
                }
                return 1 // DEFAULT
            },
            pageSize() {
                if (this.rows && this.rows.length > 0) {
                    let firstRow = this.rows[0]
                    if (firstRow) {
                        return firstRow.pageSize
                    }
                }
                return 10 // DEFAULT
            }
        },
        methods: {
            viewJson (json) {
                this.jsonValue = JSON.parse(json)
                this.$bvModal.show('json-viewer-modal-' + this.$vnode.key)
            },
            viewSource(source) {
                this.rowSourceVal = source
                this.$bvModal.show('text-viewer-modal-' + this.$vnode.key)
            },
            showRow (idx) {
                this.selectedRowIndex = idx
            },
            hideRow () {
                this.selectedRowIndex = -1
            },
            search({ searchValues, onlyExceptions }) {
                this.loading = true
                this.getSupplierImportLines({ supplierImportFileId: this.file, searchValues, onlyExceptions, pageNumber: this.pageNumber, pageSize: this.pageSize })
                    .then((res) => {
                        let { data, messages, pagination } = res.data
                        if (data) {
                            this.rows = data
                        } else {
                            this.rows = null
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                    })
                    .finally( () => this.loading = false)
            },
            getSupplierImportLines(payload) {
                let baseUrl = API_BASE_URL
                return axios.post(baseUrl + '/api/admin/v1/partnerimport/rows', payload)
            }
        },
        beforeMount() {
            if (this.page && this.page > 0) {
                this.pageNumber = this.page
            } else {
                this.pageNumber = 1
            }
            this.search({})
        }
    }
</script>

<style>
</style>
